// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.rankingTabRow[data-v-6f2b95b5] {\n  position: relative;\n  width: 100%;\n}\n.rankingTabRow[data-v-6f2b95b5] #rankingTab > .el-tabs__header .el-tabs__nav-wrap {\n  padding-right: 90px;\n}\n.rankingTabRightButton[data-v-6f2b95b5] {\n  position: absolute;\n  right: 0;\n  top: 14px;\n  z-index: 2;\n}\n.tableSpecial[data-v-6f2b95b5] table tr:nth-child(1) {\n    line-height: 35px;\n}\n.tableSpecial[data-v-6f2b95b5] .col-divider-left {\n    border-left: 1px solid #ebeef5 !important;\n}\n\n/* Hide grouped-header middle divider only for within-year grouped columns before expansion. */\n.tableSpecial.no-within-year-rank-line[data-v-6f2b95b5] .within-year-group-head {\n  border-bottom: 0 !important;\n}\n.tableSpecial.no-within-year-rank-line[data-v-6f2b95b5] .within-year-group-subhead {\n  border-top: 0 !important;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rankingTabRow": "rankingTabRow",
	"rankingTab": "rankingTab",
	"el-tabs__header": "el-tabs__header",
	"el-tabs__nav-wrap": "el-tabs__nav-wrap",
	"rankingTabRightButton": "rankingTabRightButton",
	"tableSpecial": "tableSpecial",
	"col-divider-left": "col-divider-left",
	"no-within-year-rank-line": "no-within-year-rank-line",
	"within-year-group-head": "within-year-group-head",
	"within-year-group-subhead": "within-year-group-subhead"
};
module.exports = ___CSS_LOADER_EXPORT___;
